<template>
  <!-- Start Preferences -->
  <div class="options">
    <p v-if="showTitle" class="text-center font-weight-bold my-3 options">
      {{ $t("text.select_preferences") }}
    </p>
    <el-collapse v-model="activeNames">
      <el-collapse-item v-for="(option, optIndex) in options" :key="optIndex" :name="option.id">
        <template slot="title">
          <div class="media w-100">
            <div class="media-body text-sm ">
              <span class="font-weight-bolder option-name">{{ option.name }} </span><span v-if="isDeliverect" class="option-max-min" >{{ option.max_quantity != 1 ? `Min
                              ${option.min_quantity}, Max ${option.max_quantity == 0 ? '*' : option.max_quantity}` : ''
              }}</span>
            </div>
            <div class="d-flex align-items-center">
              <span v-if="getOptionTotal(option) > 0" class="text-success text-sm mr-2">{{ getOptionTotal(option) |
  currency }}</span>
              <span v-if="option.is_required" class="text-danger text-xl mr-2 mt-2">*</span>
            </div>
          </div>
        </template>
        <div class="media">
          <p class="text-gray mb-2 media-body">
            {{
              option.type === OPTION_TYPE.checkbox
              ? "Please select one or many of these option"
              : "Please select any of these option"
            }}
          </p>
          <div v-if="option.type !== OPTION_TYPE.checkbox" class="remove clickable" :class="
            selectedValues(option).length ? 'show' : 'hide'
          " @click="onClearSelectedValue({ option })">
            <i class="el-icon-delete text-danger font-weight-bolder"></i>
          </div>
        </div>

        <div v-if="option.type === OPTION_TYPE.checkbox">
          <div class="text-black option-checkbox-values" v-for="(value, valueIndex) in option.values" :key="valueIndex">
            <div class="media">
              <el-button :type="
                checkIfValueSelected(option, value.id)
                  ? 'primary'
                  : 'default'
              " class="mb-1" circle @click.prevent="onValueSelected({ option, value })">
                <span v-if="checkIfValueSelected(option, value.id)">{{
                  checkIfValueSelected(option, value.id)
                }}</span>
                <i v-else class="el-icon-plus"></i>
              </el-button>
              <div class="media-body d-flex flex-column">
                <div class="clickable" @click.prevent="onValueSelected({ option, value, update: true })">{{ value.name }}
                </div>
                <div v-if="value.options && value.options.length">
                  <div v-for="(subOption, subOptionIndex) in value.options" :key="subOptionIndex">
                    <div v-for="(selectecValue, indexSelectecValue) in subOption.selected_items" :key="indexSelectecValue"
                      class="d-flex">
                      <span>++ {{ selectecValue.name }}</span>
                      <StepperInput :option="subOption" :value="selectecValue" :parent-option="option" class="ml-3"
                        @increase="handleIncrease" @decrease="handleDecrease" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="price text-center">
                {{ value.price | currency }}
              </div>

              <div class="remove clickable" :class="
                checkIfValueSelected(option, value.id) ? 'show' : 'hide'
              " @click="onClearSelectedValue({ option, value })">
                <i class="el-icon-delete text-danger font-weight-bolder"></i>
              </div>
            </div>
          </div>
        </div>
        <div v-if="option.type === OPTION_TYPE.select">
          <el-select v-model="option.selected" placeholder="Select an option" class="w-100"
          @change="(value) => onValueSelected({ option, value: option.values.find(val => val.id == value), isSingle: true, update: true })"
          >
            <el-option v-for="( item, itemIndex ) in option.values" :key="itemIndex" :label="item.name" :value="item.id"
             >
              <div class="media el-option">
                <div class="media-body name font-weight-bold">{{ item.name }}</div>
                <div class="price" v-if="item.price">
                  {{ item.price | currency }}
                </div>
              </div>
            </el-option>
          </el-select>
          <p class="text-gray text-xs mb-0" v-if="isValueSelected(option.selected)">
            <span v-for="(selectedValue, index) in selectedValues(option)" :key="index">
              {{ selectedValue.name }} {{ selectedValue.price | currency }}
            </span>
          </p>
        </div>
        <div v-if="option.type === OPTION_TYPE.radio">
          <el-radio-group v-model="option.selected" class="d-flex flex-column">
            <el-radio v-for="(value, index) in option.values" :key="index" class="media text-black w-100 el-reverse-radio"
              :label="value.id" @change="onValueSelected({ option, value, isSingle: true, update: true })">

              <div class="media-body">
                <div class="d-flex flex-column">
                  <div class="clickable"
                    @click.prevent="onValueSelected({ option, value, isSingle: true, update: true })"> {{ value.name }}
                  </div>
                  <div v-if="value.options.length" v-html="formatSelectedItems(value.options)"></div>
                </div>
              </div>
              <div class="price text-center" v-if="value.price">
                {{ value.price | currency }}
              </div>

            </el-radio>

          </el-radio-group>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
  <!-- End Preferences -->
</template>
<script>
import { OPTION_TYPE } from "@/utilities/enums";
import { isEmpty, getOptionTotal, formatSelectedItems, checkMaxQuantitySelectedByOption, getAllSelectItems } from "@/utilities/helper";
import StepperInput from './StepperInput'
export default {
  components: {
    StepperInput
  },
  props: {
    options: Array,
    showTitle: {
      type: Boolean,
      default: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
    isDeliverect:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      getOptionTotal,
      formatSelectedItems,
      OPTION_TYPE,
      selectedOption: null,
      currentValues: [],
      activeNames: [],
    };
  },
  computed: {
    isValueSelected() {
      return (value) => {
        return isEmpty(value);
      };
    },
    selectedValues() {
      return (option) => {
        const selected = option.selected_items.map(s => s.id)
        return option.values.filter((x) => selected.includes(x.id));
      };
    },
    checkIfValueSelected() {
      // only used for checkbox type
      return (option, value_id) => {
        if (!option.selected_items?.length) return 0;
        return option.selected_items.find((x) => x.id == value_id)?.quantity;
      };
    }
  },
  mounted() {
    if (this.collapse) {
      this.activeNames = this.options.map(o => o.id)
    }
  },
  created() {
    this.$root.$on("PUSH_VALUE_OPTIONS", (data) => {
      this.addSelectedSubOptions(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("PUSH_VALUE_OPTIONS");
  },
  methods: {
    onValueSelected(item) {

      if (!item.option.selected) {
        this.$set(item.option, 'selected', [])
      }
      if (!item.option.selected_items) {
        this.$set(item.option, 'selected_items', [])
      }

      // when we selecting different value , we have to clear any selected sub option for the other values
      if (item.isSingle) {
        let otherValues = item.option.values.filter(v => v.id != item.option.selected)
        otherValues.forEach(value => {
          if (value.options.length) {
            value.options.forEach(option => {
              option.selected = null
              option.selected_items = []
            })
          }
        });
        // add the selected value to the option
        this.addSelectedSubOptions(item);
      }

      let isValueSelected = this.checkIfValueSelected(item.option, item.value.id);
      if (item.value?.options?.length && (!isValueSelected || (isValueSelected && item.update))) {
        this.$parent.$parent.$emit("onShowValueOptions", item);
      }
      // check if the max quantity is eached by value , and by option
      if (checkMaxQuantitySelectedByOption(item.option, item.value)) {
        return false;
      }
      if (!item.isSingle) {
        item.option.selected.push(item.value.id);

        let itemFound = item.option.selected_items.find(
          (x) => x.id === item.value.id
        );

        if (itemFound) {
          if (!item.update) {
            itemFound.quantity++;
          }

        } else {
          item.option.selected_items.push({
            id: item.value.id,
            name: item.value.name,
            price: item.value.price,
            quantity: 1,
          });
        }
      }
    },

    // item : {option : option, value}
    onClearSelectedValue(item) {
      let valuesToClear = item.value ? item.value : item.option.values;

      if (item.option.type == OPTION_TYPE.checkbox) {
        item.option.selected = item.value ? item.option.selected.filter((x) => x != item.value.id) : []
      } else {
        item.option.selected = ""
      }

      item.option.selected_items = item.value ? item.option.selected_items.filter(
        (x) => x.id != item.value.id
      ) : [];

      if (!item.option.selected_items.length && item.parentOption) {

        let selectedValues = item.parentOption.values.filter(v => item.parentOption.selected_items.map(s => s.id).includes(v.id))

        for (let selectedValue of selectedValues) {

          if (!selectedValue?.options?.length) continue;

          for (let subOption of selectedValue.options) {
            let hasSelectedValue = false
            if (getAllSelectItems(subOption).length) {
              hasSelectedValue = true;
            }
            if (!hasSelectedValue) {
              item.parentOption.selected_items = item.parentOption.selected_items.filter(s => s.id != selectedValue.id);
              item.parentOption.selected = item.parentOption.type == OPTION_TYPE.checkbox ? item.parentOption.selected_items.map(s => s.id) :
                item.parentOption.selected_items.length ? item.parentOption.selected_items[0].id : "";
            }

          }
        }
      }

      if (item.option.type == OPTION_TYPE.checkbox) {
        if (item.value?.options?.length) {
          item.value.options.forEach(option => {
            this.onClearSelectedValue({ option })
          })
        }
      }
      else if (valuesToClear?.length) {

        for (const value of valuesToClear) {
          if (!value.options?.length) continue;
          for (const option of value.options) {
            if (!option.selected_items.length) continue;
            this.onClearSelectedValue({ option })
          }
        }
      }
    },
    addSelectedSubOptions(data) {

      if (data.isSingle) {
        data.option.selected = data.value.id
        data.option.selected_items = [
          {
            id: data.value.id,
            name: data.value.name,
            price: data.value.price,
            quantity: 1,
          },
        ];
        return;
      }
    },
    handleIncrease(item) {
      if (checkMaxQuantitySelectedByOption(item.option, item.value)) {
        return;
      }
      item.value.quantity++
    },
    handleDecrease(item) {
      item.value.quantity--
      if (item.value.quantity <= 0) {
        this.onClearSelectedValue(item)
      }
    }
  },
};
</script>